import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { roleModules } from "src/atoms/roleModules.atom";
import { CONSTANTS } from "src/constants";
import { AuthValue } from "src/models/layout.models";
import { UserModule } from "src/models/user.model";
import API_SERVICES from "src/services";
import { urlPermission } from "src/utils/common.utils";

import { useAuth } from "../context/userContext";

import AdminLayout from "./AdminLayout";

import "react-toastify/dist/ReactToastify.css";

const LayoutProtected: React.FC = () => {
  const { user } = useAuth() as AuthValue;
  const [flag, setFlag] = useState(false);
  const profile = localStorage.getItem(
    CONSTANTS.LOCAL_STORAGE.PROFILE
  ) as string;
  const navigate = useNavigate();
  const setUserModules = useSetRecoilState(roleModules);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!JSON.parse(profile)) {
      navigate("/", { replace: true });
    } else {
      getRoleModules();
    }
  }, [pathname, navigate]);

  const getRoleModules = async () => {
    const res: UserModule[] = await API_SERVICES.USER.GET_ROLE_MODULES();
    setUserModules(res);
    const response = urlPermission(res, pathname);
    if (!response.permission.length) {
      // navigate("/admin/dashboard", { replace: true });
      setFlag(false);
    } else {
      setFlag(true);
    }
  };

  return flag ? user && <AdminLayout /> : <></>;
};

export default LayoutProtected;
